export default __webpack_public_path__ + "static/media/InsideLungs_08.662de03f.png";